import type User from "@/Types/Models/User";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default function useGuard() {
    const page = usePage();

    const user = computed((): User => page.props.auth.user);

    function has(...permissions: string[]) {
        const neededPermissions = permissions.flat(Infinity);

        // make sure that every needed permission is in the user permissions
        const userHasAllNeededPermissions = neededPermissions.every((eachPermission) =>
            user.value.permissions.includes(eachPermission),
        );

        return userHasAllNeededPermissions;
    }

    function hasAny(...permissions: string[]) {
        const neededPermissions = permissions.flat(Infinity);

        // make sure that user has at least 1 permission
        const userHasAllNeededPermissions = neededPermissions.some((eachPermission) =>
            user.value.permissions.includes(eachPermission),
        );

        return userHasAllNeededPermissions;
    }

    function can(...permissions: string[]) {
        return has(...permissions);
    }

    return {
        user,
        has,
        hasAny,
        can,
    };
}
